'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMetadata = undefined;

var _core = require('lodash/core');

var _core2 = _interopRequireDefault(_core);

var _sdk = require('wave-charts/sdk');

var _sdk2 = _interopRequireDefault(_sdk);

var _metadata = require('./metadata.json');

var _metadata2 = _interopRequireDefault(_metadata);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var formatNumber = _sdk2.default.formatNumber;
var ThemeFactory = _sdk2.default.ThemeFactory;
var layoutBuilder = _sdk2.default.layoutBuilder;
var ref = _sdk2.default.utils;
var constants = ref.constants;
var plotUtils = ref.plotUtils;
var scales = ref.scales;
var configUtils = ref.configUtils;
var ref$1 = _sdk2.default.shapes;
var Text = ref$1.Text;
var NumberText = ref$1.NumberText;
var Layer = ref$1.Layer;
var Point = ref$1.Point;
var Line = ref$1.Line;
var ShapeGroup = ref$1.ShapeGroup;
var Cell = ref$1.Cell;
var defaultTheme = ThemeFactory.getInstance().getDefaultTheme();

var AbstractLegend = function AbstractLegend(config, rows) {
  this.config = config;
  this.rows = rows || [];
  configUtils.convertConfigColors(config);

  _core2.default.defaults(config, this.getDefaultConfig());

  this.sanitizeConfig();
};

AbstractLegend.prototype.sanitizeConfig = function sanitizeConfig() {};

AbstractLegend.prototype.extendConfig = function extendConfig(configExtend) {
  _core2.default.extend(this.config, configExtend);

  configUtils.convertConfigColors(this.config);
  this.sanitizeConfig();
};

AbstractLegend.prototype.getConfig = function getConfig() {
  return this.config;
};

AbstractLegend.prototype.getDefaultConfig = function getDefaultConfig() {
  return {
    swatchSize: constants.COLOR_LEGEND.SWATCH.SIZE,
    swatchPadding: constants.COLOR_LEGEND.SWATCH.PADDING,
    fitWidth: true,
    fitHeight: true,
    showHeader: true,
    showBackground: false,
    headerAlign: "left",
    theme: defaultTheme,
    selectMode: constants.SELECTMODE.NONE,
    transforms: {}
  };
};

AbstractLegend.prototype.getHeaderSize = function getHeaderSize(isVerticalLayout) {
  var ref = this.config;
  var headerText = ref.headerText;
  var showHeader = ref.showHeader;
  var width = 0;
  var height = 0;

  if (showHeader && headerText) {
    width = plotUtils.getTextWidth(headerText) + constants.LEGEND.PADDING;
    height = constants.LEGEND.TEXT.SIZE + (isVerticalLayout ? constants.LEGEND.PADDING : 2 * constants.LEGEND.PADDING);
  }

  return [width, height];
};

AbstractLegend.prototype.render = function render(headerCell, plotCell) {
  var config = this.config;
  var size = config.size;
  var selectMode = config.selectMode;
  var selectionKeyFct = config.selectionKeyFct;
  var swatchSize = config.swatchSize;
  var showHeader = config.showHeader;
  var showBackground = config.showBackground;
  var headerText = config.headerText;
  var position = config.position;
  var transforms = config.transforms;
  var rows = this.rows;
  var theme = config.theme;
  var horizontalLayout = config.transforms.rotate;
  var scene = headerCell ? headerCell.getScene() : null;

  if (!headerCell || !plotCell) {
    scene = layoutBuilder.build({
      layout: "Legend",
      size: size,
      position: position,
      transforms: transforms,
      selectMode: selectMode,
      selectionKeyFct: selectionKeyFct
    }); // Build the legend scene:

    plotCell = scene.cellByKey("plot");
    headerCell = scene.cellByKey("header");
  }

  var padding = config.swatchPadding;
  var headerLayer;
  var headerBb; // draw header

  if (showHeader && headerText) {
    headerLayer = this.plotHeader({
      cell: headerCell,
      text: headerText,
      horizontalLayout: horizontalLayout,
      padding: padding,
      dx: horizontalLayout ? headerCell.get("w") / 2 : swatchSize / 2 + padding,
      theme: theme
    });
    headerBb = headerLayer.boundingBox();
  } // adjust header row


  scene.adjustRowToFit(headerCell.get("row"));
  var initWidth = showHeader && !horizontalLayout && headerBb ? headerBb.w + padding : plotCell.get("w");
  var initHeight = plotCell.get("h");

  if (!this.plotFunction) {
    throw "'plotFunction' is not defined for for your legend subclass.";
  }

  this.plotFunction(plotCell, rows, initWidth, initHeight);

  if (plotCell.getLayers().length === 0) {
    return this.emptyLegend(config);
  } // draw header bottom line


  if (showHeader && headerText) {
    this.plotHeaderLine(headerLayer, padding, horizontalLayout, Math.max(headerCell.get("w"), plotCell.get("w")), null, theme);

    if (config.headerAlign === "center" && !horizontalLayout) {
      var headerTextShape = headerLayer.getShapes()[0];
      headerTextShape.set({
        x: plotCell.get("w") / 2 + 3,
        halign: "center"
      });
    }
  } // background


  if (showBackground) {
    scene.set({
      background: theme.getLegendBGColor()
    });
  }

  scene.set({
    config: this.config
  });
  return scene;
};

AbstractLegend.prototype.emptyLegend = function emptyLegend(config) {
  return layoutBuilder.build({
    layout: "Legend",
    size: config.size,
    transforms: config.transforms,
    selectMode: config.selectMode
  });
};

AbstractLegend.prototype.plotHeader = function plotHeader(config) {
  var theme = config.theme || defaultTheme;
  var cell = config.cell;
  var text = config.text;
  var horizontalLayout = config.horizontalLayout;
  var padding = config.padding;
  var halign = config.halign || "left";
  var valign = config.valign || "top";
  var dx = config.dx;
  var headerLayer = new Layer({
    cell: cell,
    key: "header"
  });
  var headerProps = horizontalLayout ? {
    x: dx,
    valign: "middle",
    halign: "right",
    maxWidth: cell.get("h"),
    vertical: true,
    padding: {
      left: 0,
      right: padding
    }
  } : {
    valign: valign,
    halign: halign,
    maxWidth: cell.get("w"),
    padding: {
      left: padding / 2,
      right: padding / 2,
      top: 3,
      bottom: padding - 2
    }
  };
  new Text(_core2.default.extend({
    layer: headerLayer,
    key: "header-text",
    text: text,
    stroke: theme.getLegendHeaderColor()
  }, headerProps));
  return headerLayer;
};

AbstractLegend.prototype.plotHeaderLine = function plotHeaderLine(headerLayer, padding, horizontalLayout, totalWidth, overrides, theme) {
  theme = theme || defaultTheme;
  var header = headerLayer.getCell();

  if (!header) {
    return;
  }

  var headerBb = headerLayer.boundingBox();
  var config = overrides ? overrides : {};

  _core2.default.defaults(config, {
    layer: headerLayer,
    key: "line",
    x0: horizontalLayout ? headerBb.x - padding / 2 : 0,
    y0: header.get("h") - 1,
    x1: horizontalLayout ? headerBb.x + constants.LEGEND.TEXT.SIZE + padding / 2 : totalWidth,
    y1: header.get("h") - 1,
    lineWidth: 2,
    stroke: theme.getLegendHeaderLineColor()
  });

  return new Line(config);
};

AbstractLegend.prototype.isEmpty = function isEmpty(rows) {
  return false;
};

exports.default = AbstractLegend;

var getMetadata = function getMetadata() {
  return _metadata2.default;
};

exports.getMetadata = getMetadata;